import { getOfflineData } from "./offline-services";

export const HOME_TABS = {
  BUDGET: "budget",
  PR: "pr",
  PO: "po",
  GRN: "grn",
  ADVANCE_PAYMENT: "advancePayment",
};

const HOME_TAB_INDEX = {
  finance: { budget: 1, pr: 2, po: 3, grn: 4, advancePayment: 5 },
  vendor: { po: 0, grn: 1 },
  // regular: { pr: 1, po: 2, grn: 3, advancePayment: 4 },
  regular: { pr: 1, po: 2, grn: 3, advancePayment: 4, budget: 9 },
};

const getHomeBranch = () => {
  const role = getOfflineData("user")?.role?.toUpperCase() || "";
  if (role.includes("FINANCE") || role.includes("ADMIN") || role.includes("BUDGET")) {
    return "finance";
  }
  if (role.includes("VENDOR")) {
    return "vendor";
  }
  return "regular";
};

export const getHomeTabUrl = (tab, subIndex) => {
  const index = HOME_TAB_INDEX[getHomeBranch()]?.[tab];
  if (index === undefined) {
    return "/finance-v2";
  }
  return subIndex === undefined
    ? `/finance-v2?index=${index}`
    : `/finance-v2?index=${index}&subIndex=${subIndex}`;
};

export const getPoListSubIndex = (status) => {
  switch (status) {
    case "draft":
      return 0;
    case "approval_in_progress":
      return 1;
    case "approved":
      return 3;
    case "reconsider":
      return 4;
    default:
      return 5;
  }
};
